const xmCloudApi = {
  get_organization: {
    scope: 'xmclouddeploy.organizations:manage',
    url: '/api/organizations/v1',
  },
};

function getXMCloudDeployBaseUrl(env: string) {
  const environment = env.toLowerCase();

  const map = {
    dev: 'https://xmclouddeploy-api-staging.sitecore-staging.cloud',
    staging: 'https://xmclouddeploy-api-staging.sitecore-staging.cloud',
    'pre-production': 'https://xmclouddeploy-api-preprod.sitecorecloud.io',
    preprod: 'https://xmclouddeploy-api-preprod.sitecorecloud.io',
    production: 'https://xmclouddeploy-api.sitecorecloud.io',
  }[environment];

  return map || '';
}

export { xmCloudApi, getXMCloudDeployBaseUrl };
